module.exports = __webpack_public_path__ + "static/media/agenda-del-pages-2018-edited.8d355da2.png";